import { Routes } from '@angular/router';

import { MpsIsAdminGuard } from '../mps/guards/mps-isadmin.guard';
import { MpsLoggedInGuard } from '../mps/guards/mps-loggedin.guard';
import { applicationRouteNames } from './application-route-names';

export const applicationRoutes: Routes = [
  {
    path: applicationRouteNames.home,
    loadComponent: () => import('./projects/project-home/project-home.component').then((m) => m.ProjectHomeComponent),
    data: { title: 'general.navigation.home' },
    canActivate: [MpsLoggedInGuard],
    canLoad: [],
  },
  {
    path: applicationRouteNames.referentials,
    loadComponent: () => import('./administration/referentials/home/home.component').then((m) => m.HomeComponent),
    data: { title: 'general.navigation.referentials' },
    canActivate: [MpsLoggedInGuard],
    canLoad: [MpsLoggedInGuard],
  },
  {
    path: applicationRouteNames.administration,
    data: { title: 'general.navigation.administration' },
    canActivate: [MpsIsAdminGuard],
    canLoad: [MpsIsAdminGuard],
    children: [
      {
        path: applicationRouteNames.users,
        loadComponent: () => import('./administration/users/list/list.component').then((m) => m.ListComponent),
        data: { title: 'general.navigation.users' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
      {
        path: applicationRouteNames.lokalise,
        loadComponent: () => import('./administration/lokalise/lokalise.component').then((m) => m.LokaliseComponent),
        data: { title: 'general.navigation.lokalise' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
      {
        path: applicationRouteNames.globalRates,
        loadComponent: () => import('./administration/global-rates/home/home.component').then((m) => m.HomeComponent),
        data: { title: 'general.navigation.global_rates' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
    ],
  },
  {
    path: applicationRouteNames.project,
    canActivate: [MpsLoggedInGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./projects/project-detail/project-detail.component').then((m) => m.ProjectDetailComponent),
      },
      {
        path: applicationRouteNames.phase,
        loadComponent: () => import('./phases/phase-home/phase-home.component').then((m) => m.PhaseHomeComponent),
      },
      {
        path: applicationRouteNames.scenarioDetails,
        loadComponent: () =>
          import('./projects/scenario-details/scenario-details.component').then((m) => m.ScenarioDetailsComponent),
      },
    ],
  },
];
